import React from 'react';

const Header = () => {
    return (
        <header className="terminal-header">
            <div className="output">
                <div>Welcome to Ayush's Portfolio v1.0.0</div>
                <div>System check... OK</div>
                <div>Loading profile...</div>
            </div>
            <div className="command-line">
                <span className="prompt">root@kumar-ayush:~$</span>
                <span className="command">./init_portfolio.sh</span>
            </div>
            <div className="output">
                <h1 className="name" style={{ color: '#00ff00', textShadow: '0 0 5px #00ff00' }}>
                    &gt; KUMAR AYUSH
                </h1>
                <h2 className="title" style={{ color: 'white', opacity: 0.8 }}>
                    [ Full Stack Developer ]
                </h2>
            </div>
        </header>
    );
};

export default Header;
